import axios from 'lib/axios'

export const getNotifications = async ({
    page = 1,
    perPage = 20,
    search = '',
    type = 'all',
    isRead,
} = {}) => {
    const params = {
        page,
        per_page: perPage,
    }

    if (search?.trim()) {
        params.search = search.trim()
    }

    if (type && type !== 'all') {
        params.type = type
    }

    if (typeof isRead === 'boolean') {
        params.is_read = isRead
    }

    const response = await axios.get('/notifications/inbox', {
        params,
    })

    return response.data
}

export const markNotificationAsRead = async (id) => {
    const response = await axios.post(`/notifications/${id}/read`)
    return response.data
}

export const markAllNotificationsAsRead = async () => {
    const response = await axios.post('/notifications/read-all')
    return response.data
}

// push notifications desktop
export const getPushInterests = async () => {
  const response = await axios.get('/notifications/push-interests')
  return response.data
}